import React from 'react';
import styles from '../../styles/molecules/friend-modal.module.scss';
import Modal from './Modal';

interface FriendModalProps {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  hurigana?: string;
  subName?: string;
  image: string;
  imageWidth: number;
  characters: string[];
}

export const FriendModal: React.FC<FriendModalProps> = ({
  isOpen,
  onClose,
  name,
  hurigana,
  subName,
  image,
  imageWidth,
  characters,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} >
      <div className={styles.friendModal}>
        <img src={require(`assets/images/${image}`)} alt={name} width={imageWidth} />
        <div className={styles.friendModalContent}>
          <h2 className={styles.nameWrapper}>
            <p className={styles.name}>
              {hurigana && <span className={styles.hurigana}>{hurigana}</span>}
              {name}
            </p>
            {subName && <span className={styles.subName}>{subName}</span>}
          </h2>
          <ul>
            {characters.length > 0 ? (
              characters.map((character, index) => (
                <li key={index}>{character}</li>
              ))
            ) : (
              <li className={styles.preparing}>準備中</li>
            )}
          </ul>
        </div>
        <button onClick={onClose}>閉じる</button>
      </div>
    </Modal>
  );
}; 